<template>
  <div class="quiz-ctn">
    <div
      v-for="(question, key) in questions"
      class="question"
      :key="key"
    >
      <div>
        <!-- <div class="question-num">Question {{currentQuestion+1}} of {{questions.length}}</div> -->

        <div class="question-text">
          <p v-html="question.questionText"></p>
        </div>
        <div class="question-content">
          <div>
            <div
              class="radio"
              :class="{isActive: question.corrective == question.questionArray[0] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[0]"
                  v-model="question.model"
                >{{question.questionArray[0]}}</label>
            </div>

            <div
              class="radio"
              :class="{isActive: question.corrective == question.questionArray[1] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[1]"
                  v-model="question.model"
                >{{question.questionArray[1]}}</label>
            </div>

            <div
              class="radio"
              v-if="question.questionArray.length > 2"
              :class="{isActive: question.corrective == question.questionArray[2] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[2]"
                  v-model="question.model"
                >{{question.questionArray[2]}}</label>
            </div>

            <div
              class="radio"
              v-if="question.questionArray.length > 3"
              :class="{isActive: question.corrective == question.questionArray[3] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[3]"
                  v-model="question.model"
                >{{question.questionArray[3]}}</label>
            </div>

            <div
              class="radio"
              v-if="question.questionArray.length > 4"
              :class="{isActive: question.corrective == question.questionArray[4] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[4]"
                  v-model="question.model"
                >{{question.questionArray[4]}}</label>
            </div>

            <div
              class="radio"
              v-if="question.questionArray.length > 5"
              :class="{isActive: question.corrective == question.questionArray[5] && question.answer !== ''}"
              @click="scrollToButton()"
            >
              <label><input
                  :disabled="question.answer !== ''"
                  type="radio"
                  name="question"
                  :value="question.questionArray[5]"
                  v-model="question.model"
                >{{question.questionArray[5]}}</label>
            </div>

            <button
              id="checkBtn"
              class="btn-cac btn-cac--red"
              :class="{disabled: question.model == ''}"
              v-if="question.answer === ''"
              @click="submitAnswer(question.model)"
            >Vérifier</button>
          </div>
        </div>
      </div>

      <div
        class="quiz-feedback"
        v-if="question.answer !==  '' && question.answerText !== ''"
        v-html="question.answerText"
      ></div>
      <button
        class="btn-cac btn-cac--red"
        :disabled="question.model == ''"
        :class="{disabled: question.model == ''}"
        v-if="question.answer !== ''"
        @click="$emit('quiz-complete')"
      >{{questionStatus}}</button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    questions: Array,
    qid: String,
  },
  data() {
    return {
      quizScore: [],
      currentQuestion: 0,
      quizCompleted: false,
      feedbackIsOn: false
    };
  },
  methods: {
    populateQuizScore() {
      const arr = [];
      for (let i = 0; i < this.questions.length; i++) {
        arr.push('incorrect');
      }
      return arr;
    },
    // QUIZ CORRECTIVE
    checkCorrect(q, c) {
      let sortedQuestions;
      let sortedCorrective;
      if (Array.isArray(q)) {
        sortedQuestions = q.sort();
        sortedCorrective = c.sort();
        if (sortedQuestions.length !== sortedCorrective.length) {
          this.quizScore[this.currentQuestion] == 'incorrect';
          return;
        }
        for (let i = 0; i < q.length; i++) {
          if (sortedQuestions[i] !== sortedCorrective[i]) {
            this.quizScore[this.currentQuestion] == 'incorrect';
            return;
          }
        }
      } else if (q != c) {
        this.quizScore[this.currentQuestion] == 'incorrect';
        return;
      }

      this.quizScore[this.currentQuestion] = 'correct';
    },
    scrollToButton() {
      // setTimeout(function() {
      // 		$('html, body').animate({
      // 				scrollTop: $('#checkBtn').offset().top +110
      // 		}, 1000);
      // }, 400);
    },
    submitAnswer(q) {
      if (q == '' || q == null) {
        return;
      }

      this.questions[this.currentQuestion].answer = q;
      this.checkCorrect(q, this.questions[this.currentQuestion].corrective);
      this.feedbackIsOn = true;

      setTimeout(() => {
        $('html, body').animate({
          scrollTop: $('.quiz-feedback').offset().top,
        }, 1000);
      }, 400);
      if (totalScore >= this.questions.length) {
        console.log('perfect!');
        this.$emit('max-score');
      }
    },

    nextQuestion() {
      if (this.currentQuestion >= this.questions.length - 1) {
        this.quizCompleted = true;

        let totalScore = 0;

        for (let i = 0; i < this.quizScore.length; i++) {
          console.log(this.quizScore[i]);
          if (this.quizScore[i] === 'correct') {
            totalScore++;
          }
        }
        this.$emit('quiz-completed');
        // Disabled in that instance (transferred to "submitAnswer()")
        // if (totalScore >= this.questions.length) {
        //     console.log('perfect!')
        //     this.$emit('max-score')
        // }
        // console.log('emit')
        // return
      }
      // Disabled in that instance
      // this.currentQuestion ++
    },

    retry() {
      this.currentQuestion = 0;
      this.quizScore = this.populateQuizScore();
      this.quizCompleted = false;

      for (let i = 0; i < this.questions.length; i++) {
        this.questions[i].answer = '';
        this.questions[i].model = [];
      }
    },
  },
  computed: {
    questionStatus() {
      if (this.currentQuestion >= this.questions.length - 1) return 'Compris';
      return 'Next question';
    },
    computeScore() {
      let totalScore = 0;
      for (let i = 0; i < this.quizScore.length; i++) {
        console.log(this.quizScore[i]);
        if (this.quizScore[i] === 'correct') {
          totalScore++;
        }
      }
      return totalScore;
    },
    isClassCorrective() {
      for (let i = 0; i < this.questions[this.currentQuestion].corrective.length; i++) {
        if (this.quizValue == this.questions[this.currentQuestion].corrective[i] && this.questions[this.currentQuestion].answer != '') {
          return true;
        }
      }
      return false;
    },
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/*------------------------------------*\
      #CREATIVE CONCEPT PRIMARY COLOURS
  \*------------------------------------*/
@import "../styles/colors";
$magenta: #981f37;

/*------------------------------------*\
  #STYLES TO BE EXTENDED
  \*------------------------------------*/
%CTA-btn {
  background: $magenta;
  color: #fff;
  border-radius: 50px;
  padding: 15px 30px;
  margin: 10% auto;
  display: block;
  &:focus {
    color: #fff !important;
  }
}

/**
    * QUIZ
    */
.quiz {
  background: #fff;
  padding: 3% 8%;
  // margin: 5% auto 0% auto;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  // box-shadow: 5px 0 5px 8px rgba(136, 136, 136, 0.25);
  .question-num {
    font-weight: 800;
    margin-bottom: 5%;
  }
}

.quiz-scenario {
  background-color: #dcdcdc;
  border-top: none;
  border-bottom: none;
}

.quiz-feedback {
  background: #fff;
  color: $charcoal;
  padding: 1rem;
  margin-top: 1rem;
  box-shadow: 0px 0px 5px rgba($color: #000000, $alpha: 0.2);
}

.question-text {
  // color: $red;
  // font-weight: 600;
}

.question-content {
  padding: 0em 0;
  // font-size: 0.9em;

  .isActive {
    // background-color: $drkGrey;
    background-color: $feedback-green;
    color: #000;
    font-weight: 700;
  }

  .correct {
    border: 2px solid $feedback-green !important;
    color: #000;
  }

  .incorrect {
    border: 2px solid red !important;
  }

  .radio {
    // border: 1px solid $red;
    padding: 0.6em;
    margin: 0.5rem 0px;
    width: 100%;

    label {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }
    input[type="radio"] {
      /* one way to help with spacing */
      margin-right: 12px;
      min-width: 16px !important;
      min-height: 16px;
    }
  }

  a {
    text-decoration: none;
  }

  .btn {
    @extend %CTA-btn;

    margin: 1em 0;

    &--retry {
      margin: 2em auto;
    }
  }

  .disabled {
    opacity: 0.5;
  }
}
/*------------------------------------*\
		#MEDIA SCREENS > 767px (TABLETS)
	\*------------------------------------*/
@media (min-width: 47.93em) {
}
//For MAXIMUM width of 992px
@media (max-width: 992px) {
}
/*------------------------------------*\
		#MEDIA SCREENS > 992px
		(LAPTOP, TABLET)
	\*------------------------------------*/
@media (min-width: 992px) {
}
/*------------------------------------*\
		#MEDIA SCREENS > 1200px (DESKTOP)
	\*------------------------------------*/
@media (min-width: 75em) {
}
/*------------------------------------*\
		#MEDIA SCREENS > 1320px (DESKTOP)
	\*------------------------------------*/
@media (min-width: 1320px) {
}
/*------------------------------------*\
		#MEDIA SCREENS > 1600px (DESKTOP)
	\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
